import React from 'react';
import PropTypes from 'prop-types';

import {Button} from 'views/components';
import {translate} from 'views/module';

import SubscribeUserDialog from '../dialogs/SubscribeUserDialog';
import ConfirmDialog from '../dialogs/ConfirmDialog';

const EmailNotification = (props) => {
  const {clientBackend, relationshipData, emailData} = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [confirmAction, setConfirmAction] = React.useState(null);
  const [confirmDialogProps, setConfirmDialogProps] = React.useState({});
  const [email, setEmail] = React.useState(emailData.email ?? '');

  React.useEffect(() => {
    setEmail(emailData.email);
  }, [emailData.email]);

  const createUserEmail = async (email) => {
    setIsLoading(true);
    await clientBackend.notification.createUserEmail(relationshipData.relationshipRn, email, () => setIsLoading(false));
  };

  const removeUserEmail = async () => {
    setIsLoading(true);
    await clientBackend.notification.removeUserEmail(relationshipData.relationshipRn, email, () => setIsLoading(false));
  };

  const handleOpenDialog = () => {
    setEmail(email.trim());
    setShowDialog(true);
  };

  const handleConfirm = async () => {
    if (confirmAction) {
      await confirmAction();
    }
    setShowConfirmDialog(false);
  };

  const getButtonConfig = () => {
    if (emailData.isSubscribedForNotification) {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Active'),
        action: () => {
          setConfirmDialogProps({
            title: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.Title'),
            message: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.Message'),
            confirmText: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.ConfirmButton'),
          });
          setConfirmAction(() => removeUserEmail);
          setShowConfirmDialog(true);
        },
      };
    } else {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Setup'),
        action: handleOpenDialog,
      };
    }
  };

  const buttonConfig = getButtonConfig();

  return (
    <>
      <Button
        onClick={buttonConfig.action}
        variant="contained"
        size="small"
        disabled={isLoading}
        sx={{color: 'color.white'}}
      >
        {buttonConfig.text}
      </Button>
      {
        showDialog &&
        <SubscribeUserDialog
          open={showDialog}
          onClose={() => {
            setShowDialog(false);
          }}
          onSubmit={(email) => {
            createUserEmail(email);
            setShowDialog(false);
          }}
          initialChannelValue={email}
          isLoading={isLoading}
          channelType={'Email'}
          channel={'Notification'}
        />
      }
      {
        showConfirmDialog &&
        <ConfirmDialog
          open={showConfirmDialog}
          title={confirmDialogProps.title}
          message={confirmDialogProps.message}
          onCancel={() => setShowConfirmDialog(false)}
          onConfirm={handleConfirm}
          confirmText={confirmDialogProps.confirmText}
          cancelText={translate('client.ClientDetail.Relationships.Contacts.Dialogs.Cancel')}
          isLoading={isLoading}
        />
      }
    </>
  );
};

EmailNotification.propTypes = {
  clientBackend: PropTypes.object.isRequired,
  emailData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    isSubscribedForNotification: PropTypes.bool.isRequired,
  }).isRequired,
  relationshipData: PropTypes.object.isRequired,
};

export default EmailNotification;
